import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CreateLocalization } from '../components/Localizations/CreateLocalization'
import { useLocalizations } from '../hooks/useLocalizations'
import { useProduct } from '../hooks/useProduct'

export const CreateLocalizationPage = () => {
  const { productId = null } = useParams<{ productId?: string }>()
  const { product, error: productError } = useProduct(productId)
  const { localizations } = useLocalizations(product?.id)

  useEffect(() => {
    if (productError?.response?.status === 404) {
      toast('Product ID does not exist.', { containerId: 'error' })
    }
  }, [productError])

  if (!productId || !product) return null

  return <CreateLocalization product={product} localizations={localizations} />
}
